import React, { Fragment, useState, useEffect, useContext } from 'react';
import { LoginContext } from '../../hooks/context/LoginContext';
import axios from 'axios';
import Cookies from 'universal-cookie';
import { Modal } from 'react-bootstrap';
import { Spinner } from 'react-bootstrap';
import FormRow from './FormRow';
import FormInput from './FormInput';
import MiSelect from './MiSelect';

import { getApiUrl, axiosPost, MiReplaceAll, getAhoraddmmyyyy, getAhorayyyymmdd, getPantDocFromNivel, setStockOptionsSelectUbiLarge, getStockOptionsSelectUbi, getTitle, encryptData, getDecodedCookie } from '../../helpers/helperApp';

function MiSelectLarge(props){

    const cookies = new Cookies();

    const { apiKey, appCryptCom} = useContext(LoginContext);   

    const { id, value, name, saveValue, saveValueIsArray, label, col, confPantalla, dataType, multiLinea, unidad, functionAfterChange, minCharSearch, readOnly, disabled, inFormulario, styleLikeForm } = props;
    let { dataSql } = props;    

    const [ showModal, saveShowModal ] = useState(false);
    const [ loadingSearch, saveLoadingSearch ] = useState(false);
    const [ inputFiltro, saveInputFiltro ] = useState("");
    // const [ selectValue, saveSelectValue ] = useState(value.value);
    const [ selectValue, saveSelectValue ] = useState(0);
    const [ options, saveOptions ] = useState([]);          
    
    useEffect(()=>{ 
        if(minCharSearch != 0){
            saveSelectValue(value.value);
        }
    },[value, inFormulario, selectValue])


    const onKeyDown = (e) => {
        if(!inputFiltro || inputFiltro.length < 3 || loadingSearch) return;
        if (e.key === 'Enter') {           
            buscar();
        }
    };
    
    const buscar = async () => {
        saveLoadingSearch(true);

        const data = new FormData();
        data.append("validacion", apiKey());        
        const idCookie = await encryptData(cookies.get('id'), appCryptCom);
        data.append('ua', idCookie);
        const nivelCookie = await encryptData(cookies.get('nivel'), appCryptCom);
        data.append('na', nivelCookie);                            
        dataSql = await encryptData(dataSql, appCryptCom);
        data.append(dataType, dataSql);
        const like = await encryptData(inputFiltro, appCryptCom);
        data.append('like', like);  
     
        let url = null;
        if( dataType == "filter" ){
            url = getApiUrl(window.location.origin)+'/filters/getFilter';
        }else{
            url = getApiUrl(window.location.origin)+'/app/getDataCbo';
        }
        const respuesta = await axios.post(url, data);

        if(unidad && unidad.value > 0){                    
            respuesta.data = await getStockOptionsSelectUbi(respuesta.data, unidad.value);                     
            saveOptions(respuesta.data);                      
        }else{
            saveOptions(respuesta.data); 
        }

        if(respuesta.data.length == 1){            
            handleSelect({value: respuesta.data[0].value, label: respuesta.data[0].label}, "");            
        }


        saveLoadingSearch(false);
    }

    const openModal = async () => {
        saveInputFiltro("");
        saveSelectValue(0);
        saveShowModal(true);
        saveOptions([]);
        if(minCharSearch == 0){
            await buscar();
        }
    }

    const clear = () => {        
        saveSelectValue(0);        
        if (saveValueIsArray) {
            saveValue(prevState => {
                const updatedArray = Array.isArray(prevState) ? [...prevState] : [];
                const aux = updatedArray.map(item => {
                    if(item.id == saveValueIsArray.id){                        
                        item[saveValueIsArray.valuekey] = 0;
                        item[saveValueIsArray.labelkey] = "";
                    }
                    return item;                   
                });                
                return aux;
            });
        }else if(inFormulario){                
            saveValue({ ...inFormulario.formulario, [inFormulario.key]:"", [inFormulario.keylabel]:"" });
        } else {
            saveValue({ value: 0, label: "" });
        }

        if(functionAfterChange) functionAfterChange(null, {name: name});
    }

    const handleInput = (e) => {        
        const { name, value } = e.target;
        saveInputFiltro(value)        
    }

    const handleSelect = (selectedItem, nameOfComponent) => {

        if( selectedItem ){
            saveSelectValue(selectedItem.value);
            if (saveValueIsArray) {
                saveValue(prevState => {                 
                    const updatedArray = Array.isArray(prevState) ? [...prevState] : [];
                    const existingIndex = updatedArray.findIndex(item => item.id === saveValueIsArray.id);
                        
                    if (existingIndex !== -1) {
                        updatedArray[existingIndex][saveValueIsArray.valuekey] = selectedItem.value;
                        updatedArray[existingIndex][saveValueIsArray.labelkey] = selectedItem.label;
                    }                                                                            
                    return updatedArray;
                });
            }else if(inFormulario){                
                saveValue({ ...inFormulario.formulario, [inFormulario.key]:selectedItem.value, [inFormulario.keylabel]:selectedItem.label });                
            } else {
                saveValue({ value: selectedItem.value, label: selectedItem.label });
            }
            saveShowModal(false);
        }else{
            saveSelectValue(0);
            if (saveValueIsArray) {
                saveValue(prevState => {
                    const updatedArray = Array.isArray(prevState) ? [...prevState] : [];
                    const existingIndex = updatedArray.findIndex(item => item.id === saveValueIsArray.id);                    
        
                    if (existingIndex !== -1) {
                        updatedArray[existingIndex][saveValueIsArray.valuekey] = 0;
                        updatedArray[existingIndex][saveValueIsArray.labelkey] = "";
                    }                     
        
                    return updatedArray;
                });
            }else if(inFormulario){                
                saveValue({ ...inFormulario.formulario, [inFormulario.key]:"", [inFormulario.keylabel]:"" });                
            } else {
                saveValue({ value: 0, label: "" });
            }
        }

        if(functionAfterChange) functionAfterChange(selectedItem, nameOfComponent);
    }    

    const isHTML = (str) => {

        const doc = new DOMParser().parseFromString(str, 'text/html');
        return Array.from(doc.body.childNodes).some(node => node.nodeType === 1); // NodeType 1 es un nodo de elemento
    }

    return(
        <Fragment>        
            <div className={"form-group mb-0 col-md-"+col}>
                <input type="hidden" name={name} value={selectValue} />
                {
                    label != "" && label != null && label != undefined
                    ?
                        <label htmlFor={id}>{label}</label>          
                    :
                        null
                }                  
                <div className="input-group mb-2">                    
                    {
                    !inFormulario && isHTML(value.label) ? 
                        <div 
                            dangerouslySetInnerHTML={{ __html: value.label }}
                            className="form-control miSelectLargeDiv"
                            // style={{ backgroundColor: "rgba(255,255,255,1)", borderRight: "none", paddingTop: multiLinea ? "0px" : "inherit", overflow: "hidden" }}
                            style={{ 
                                    backgroundColor: "transparent", 
                                    border: "none",
                                    borderBottom: "1px solid #ced4da",
                                    borderRadius: "0px", 
                                    paddingTop: multiLinea ? "0px" : "inherit", 
                                    overflow: "hidden" }}
                        />
                    :
                    inFormulario || styleLikeForm == true
                    ?
                        <div 
                            dangerouslySetInnerHTML={{ __html: value.label }}
                            className="form-control miSelectLargeDiv"
                            // style={{ backgroundColor: "rgba(255,255,255,1)", borderRight: "none", paddingTop: multiLinea ? "0px" : "inherit", overflow: "hidden" }}
                            style={{ 
                                    backgroundColor: styleLikeForm == true ? "white" : "transparent",                                     
                                    border: "1px solid #ced4da",
                                    borderRadius: ".25rem",
                                    paddingTop: multiLinea ? "0px" : "inherit", 
                                    overflow: "hidden" }}
                        />                        
                    :
                        <p className="form-control"
                            style={{ 
                            backgroundColor: "transparent", 
                            border: "none",
                            borderBottom: "1px solid #ced4da",
                            borderRadius: "0px", 
                            paddingTop: multiLinea ? "0px" : "inherit", 
                            overflow: "hidden" }}
                        >
                            {value.label}
                        </p>
                    }
                    <div className="input-group-append" style={{backgroundColor : styleLikeForm == true ? "white" : "transparent" }}>
                        <button 
                            // className="btn btn-outline-secondary miSelectLargeBtn" 
                            className="btn btn-outline-primary " 
                            type="button"
                            // style={{border: "1px solid #ced4da", borderLeft: "none"}}
                            onClick={openModal}
                            disabled={ readOnly == true || disabled == true || readOnly == "readonly" || disabled == "disabled" ? true : false }                            
                        >
                            <i className='fal fa-search'></i>
                        </button>
                    </div>
                    <div className="input-group-append" style={{backgroundColor : styleLikeForm == true ? "white" : "transparent" }}>
                        <button 
                            // className="btn btn-outline-secondary miSelectLargeBtn" 
                            className="btn btn-outline-danger " 
                            type="button"
                            // style={{border: "1px solid #ced4da", borderLeft: "none"}}
                            onClick={clear}
                            disabled={ readOnly == true || disabled == true || readOnly == "readonly" || disabled == "disabled" ? true : false }
                        >
                            <i className='fal fa-times'></i>
                        </button>
                    </div>
                </div>
            </div>
            {
                showModal == true
                ?
                <Modal
                    show={showModal}
                    onHide={ () => saveShowModal(false)}                            
                    aria-labelledby="example-custom-modal-styling-title"
                    centered={true}                    
                    dialogClassName="modal-90w"                                             
                >                                           
                    <Modal.Body>
                        <FormRow>
                        {
                            isHTML(value.label) ? 
                                <div 
                                    dangerouslySetInnerHTML={{ __html: value.label }}
                                    className="text-left col-12"
                                    style={{ backgroundColor: "rgba(255,255,255,1)", borderRight: "none", paddingTop: multiLinea ? "0px" : "inherit", overflow: "hidden" }}
                                />                                                                                  
                            :
                                <p className="text-left col-12">{value.label}</p>                            
                        }
                        </FormRow>
                        {
                            minCharSearch == 0
                            ?
                                null
                            :
                                <FormRow>
                                    <div className={"form-group col-md-12"}>  
                                        <label>{confPantalla.config.trad.components.miselectlarge.modal.labelbuscar.title}</label>          
                                        <div className="form-group mb-2">
                                            <input 
                                                type="text" 
                                                className="form-control" 
                                                placeholder=""
                                                value={inputFiltro}
                                                style={{backgroundColor: "rgba(255,255,255,1)"}}
                                                onChange={ e => handleInput(e) }
                                                onKeyDown={onKeyDown}
                                            />
                                            <div className="input-group-append">
                                            </div>
                                        </div>
                                    </div>
                                </FormRow>
                        }
                        <FormRow>
                            {
                                minCharSearch == 0
                                ?
                                    null
                                :
                                    <button 
                                        className="btn btn-block btn-success mb-4" 
                                        type="button"
                                        style={{border: "1px solid #ced4da", borderLeft: "none"}}
                                        onClick={buscar}                                
                                        // disabled={ inputFiltro == "" || loadingSearch ? true : false }
                                        disabled={!inputFiltro || inputFiltro.length < 3 || loadingSearch}
                                    >
                                        <i className='fal fa-search'></i>
                                    </button>
                            }
                        </FormRow>                                               
                        <FormRow>
                            <MiSelect  
                                estadoForm=  { "" }
                                val=         { selectValue  }   
                                loading=     { loadingSearch ? true : false }
                                id=          { "" }    
                                name=        {name}
                                label=       { "" }    
                                placeholder= { "" }
                                col=         { 12 } 
                                isClearable= { true }
                                isSearchable={ true }
                                dataType=    { "codigo" }
                                data=        { options }
                                required=    { "" } 
                                disabled=    { loadingSearch ? true : false }
                                readOnly =   { loadingSearch ? true : false }
                                disablethisid={""}
                                formulario = { {id:0} } 
                                change=      { (selectedItem, nameOfComponent) => handleSelect(selectedItem, nameOfComponent) }
                                modifyOptions = { unidad && unidad.value > 0 ? setStockOptionsSelectUbiLarge : null}
                                selectinformes={unidad && unidad.value > 0 ? true : false}
                            />
                        </FormRow>
                        <p className="font-italic text-center">{options.length} {confPantalla.config.trad.components.miselectlarge.modal.resultados.title}</p>
                        {   loadingSearch ? 
                                <div style={{height:50, marginTop:5, marginBottom:10, textAlign: "center"}} >
                                    <Spinner animation="border" />
                                </div>
                            :
                            null
                        } 
                    </Modal.Body>
                    <Modal.Footer>
                        <div className='text-right'>                            
                            <button 
                                    className="btn btn-danger mt-1"
                                    onClick={ () => saveShowModal(false) }                                        
                            >
                                {confPantalla.config.trad.components.miselectlarge.modal.btncerrar.title}
                            </button>                                            
                        </div>
                    </Modal.Footer>                            
                </Modal>
                :
                    null
            }
        </Fragment>        
    )

}

export default MiSelectLarge;